<template>
  <div class="container mt-5">    
    <div class="d-flex justify-content-center" style="opacity:0.94">      
      <div class="col-lg-11">
        <div class="card mb-2">
          <div class="card-body">    
            <h5 class="text-center">CREACION DE USUARIOS PARA EXTRANJEROS</h5>  
            <div class="alert alert-info mt-4 mb-4" role="alert">
              <p>El presente formulario es para el registro de personas extranjeras, para posterior declaración de residencia.</p>
              <p><strong>Aclaración importante:</strong> El registro tiene una calidad de Declaración Jurada.
              </p>
            </div>

            <div class="row">
              <div class="col-12 col-md-4" style="border-right: 1px solid #ccc;">
                <div class="row form-group">
                  <div class="col-md-12">
                    <label>Nombre(s): <span class="text-danger lb-error" v-if="!$v.usuario.per_nombres.required">Campo requerido</span></label>
                    <span
                  class="text-danger lb-error"
                  v-if="!$v.usuario.per_nombres.letras"
                  >Solo debe ingresar letras
                </span>
                    <input 
                      type="text" 
                      placeholder="Ej.: Juan Manuel" 
                      class="form-control" 
                      v-model="usuario.per_nombres" 
                      :class="{'is-invalid': $v.usuario.per_nombres.$error}"
                      @keyup="usuario.per_nombres = usuario.per_nombres.toUpperCase()"
                    >
                    <span
                    class="text-danger lb-error"
                    v-if="!$v.usuario.per_nombres.minLength"
                    >Ingrese al menos 2 caracteres
                  </span>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-md-12">
                    <label>Primer Apellido: <span class="text-danger lb-error" v-if="!$v.usuario.per_primer_apellido.required">Campo requerido</span></label>
                    <span
                  class="text-danger lb-error"
                  v-if="!$v.usuario.per_primer_apellido.letras"
                  >Solo debe ingresar letras
                </span>
                    <input 
                      type="text" 
                      placeholder="Ej.: Mamani" 
                      class="form-control" 
                      v-model="usuario.per_primer_apellido" 
                      :class="{'is-invalid':$v.usuario.per_primer_apellido.$error}"
                      @keyup="usuario.per_primer_apellido = usuario.per_primer_apellido.toUpperCase()"
                    >
                    <span
                    class="text-danger lb-error"
                    v-if="!$v.usuario.per_primer_apellido.minLength"
                    >Ingrese al menos 2 caracteres
                  </span>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-md-12">
                    <label>Segundo Apellido:</label>
                    <span
                  class="text-danger lb-error"
                  v-if="!$v.usuario.per_segundo_apellido.letras"
                  >Solo debe ingresar letras
                </span>
                    <input 
                      type="text" 
                      placeholder="Ej.: Quispe" 
                      class="form-control" 
                      v-model="usuario.per_segundo_apellido"
                      @keyup="usuario.per_segundo_apellido = usuario.per_segundo_apellido.toUpperCase()"
                    >
                    <span
                    class="text-danger lb-error"
                    v-if="!$v.usuario.per_segundo_apellido.minLength"
                    >Ingrese al menos 2 caracteres
                  </span>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-8">
                <div class="row form-group">
                  <div class="col-md-6">
                    <label class=" mr-1">Tipo Documento: <span class="text-danger lb-error" v-if="!$v.usuario.par_tipo_documento.required">Campo requerido</span></label>
                    <select class="custom-select" 
                      v-model="usuario.par_tipo_documento"
                      :class="{'is-invalid': $v.usuario.par_tipo_documento.$error}">
                      <option value="">SELECCIONAR</option>
                      <option v-for="(item, index) in tipoDocumentos" :value="item.codigo" :key="index">{{ item.nombre }}</option>
                    </select>
                    
                  </div>
                  <div class="col-md-6">
                    <label>Nro. Documento: <span class="text-danger lb-error" v-if="!$v.usuario.per_numero_documento.required">Campo requerido</span></label>
                    <input 
                      type="text" 
                      placeholder="Ej.: 4234223" 
                      class="form-control" 
                      v-model="usuario.per_numero_documento" 
                      :class="{'is-invalid':$v.usuario.per_numero_documento.$error}"
                      @keyup="usuario.per_numero_documento = usuario.per_numero_documento.toUpperCase()"
                    >
                    <span
                    class="text-danger lb-error"
                    v-if="!$v.usuario.per_numero_documento.minLength"
                    >Ingrese al menos 5 dígitos
                  </span>
                  </div>
                </div>
                <div class="row form-group">
                  
                  <div class="col-md-6">
                    <label>Fecha de nacimiento: <span class="text-danger lb-error" v-if="!$v.usuario.per_fecha_nacimiento.required">Campo requerido</span></label>        
                    <span
                  class="text-danger lb-error"
                  v-if="!$v.usuario.per_fecha_nacimiento.fechas"
                  >Formato Correcto ej:28/05/1995
                </span>
                    <FechaNacimiento v-model="usuario.per_fecha_nacimiento"
                    :class="{'is-invalid': $v.usuario.per_fecha_nacimiento.$error}"/>
                  </div>
                  <div class="col-md-6">
                    <label>Género: <span class="text-danger lb-error" v-if="!$v.usuario.par_genero.required">Campo requerido</span></label>        
                    <select
                      class="custom-select"
                      v-model="usuario.par_genero"
                      :class="{'is-invalid': $v.usuario.par_genero.$error}"
                    >
                      <option value="">SELECCIONAR</option>
                      <option value="F">FEMENINO</option>
                      <option value="M">MASCULINO</option>
                    </select>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-md-6">
                    <label class="mr-1">Nacionalidad: <span class="text-danger lb-error" v-if="!$v.usuario.par_nacionalidad.required">Campo requerido</span></label>
                    <!-- <model-select 
                      class="custom-select"
                      :options="options" 
                      v-model="usuario.par_nacionalidad" 
                      placeholder="Seleccione País">
                    </model-select> -->
                    <select
                      class="custom-select"
                      v-model="usuario.par_nacionalidad"
                    >
                      <option value="">SELECCIONAR</option>
                      <option v-for="(item, index) in nacionalidades" :key="index" :value="item.a3_dgm">{{item.nombre}}</option>
                    </select>
                  </div>
                  <div class="col-md-6">
                      <label>Teléfono:<span class="text-danger lb-error" v-if="!$v.usuario.per_telefono.required">Campo requerido</span>
                        <span class="text-danger lb-error" v-if="!$v.usuario.per_telefono.numero">Solo debe ingresar Numeros</span>
                        <span class="text-danger lb-error" v-if="!$v.usuario.per_telefono.minLength">* Ingresar al menos 6 caracteres</span> 
                      </label>
                      <input
                        type="number"
                        placeholder="Teléfono..."
                        class="form-control"
                        v-model="usuario.per_telefono"
                        :class="{'is-invalid': $v.usuario.per_telefono.$error}"
                      
                      />
                  </div>
                </div>
                <div class="row form-group">
                  
                  <div class="col-md-8">
                      <label>Email: <span class="text-danger lb-error" v-if="!$v.usuario.per_email.required">Campo requerido</span></label>
                      <span
                  class="text-danger lb-error"
                  v-if="!$v.usuario.per_email.correo"
                  >Formato Incorrecto
                </span>
                      <input 
                        type="text" 
                        placeholder="Ej.: xxx@xxx.com" 
                        class="form-control" 
                        v-model="$v.usuario.per_email.$model"
                        :class="{'is-invalid':$v.usuario.per_email.$error}"
                      >
                  </div>
                  
                </div>

                <div class="row form-group">
                  <div class="col-md-5">
                    <label>Ingrese el siguiente código:</label>
                  </div>  
                  <div class="col-md-2">
                    <div id="captcha" class="captcha"></div> 
                  </div>
                  <div class="col-md-5">
                    <input class="form-control" type="text" v-model="captcha" placeholder="Ingrese el código CAPTCHA" id="cpatchaTextBox"/>
                  </div>
                </div>
                
              </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-12 text-right">
                  <router-link to="/seguridad/login" class="btn btn-secondary mr-2">Volver al Inicio</router-link> 
                  <b-button class="btn btn-success" @click="registrame">Registrar</b-button>
                </div>
              </div>
          </div>
        </div> 
      </div>  
    </div> 
    <Loading v-show="cargando" />   
  </div>
</template>

<script>
import { required, email, minLength, helpers } from "vuelidate/lib/validators";
import Loading from '../../components/Loading';
import FechaNacimiento from '../../components/FechaNacimiento.vue';
const letras = helpers.regex("alpha", /^[ a-zA-ZñÑäÄëËïÏöÖüÜáéíóúáéíóúÁÉÍÓÚÂÊÎÔÛâêîôûàèìòùÀÈÌÒÙ]*$/);
const numero = helpers.regex("alpha", /^[-+1234567890]*$/);
const fechas = helpers.regex("alpha", /^[[0-9]{4}-[0-9]{2}-[0-9]{2}]*$/);
const correo = helpers.regex("alpha", /^[[a-zA-Z0-9.!#$%&'*+=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)]*$/);


export default {
  name: 'empadronarExtranjero',
  components: {
    Loading,
    FechaNacimiento
  },
  
  data() {
    return {
      urldata:null,
      usuario: {
        per_numero_documento: '',
        per_nombres: '',
        per_primer_apellido: '',
        per_segundo_apellido: '', 
        per_telefono: '',
        per_fecha_nacimiento: '',
        par_genero: '',
        per_email: '',
        per_direccion: '',
        par_tipo_documento: '',
        par_nacionalidad: '',
        tipo_persona: 0,
        tipo_extranjero: '',
      },
      cargando: false,
      submitted:false,
      persona: {},
      user: {
        usr_usuario: '',
        usr_password: '',
        usr_estado_registro: 1,
        id_persona: 0,
        id_rol: 0
      }, 
      solicitud: {
        id_persona: 0,
        id_tramite: 1,
        sol_estado_registro: 1,
        id_estado: 1
      },
      tipoDocumentos: [],
      nacionalidades: [],
      options: [],
      item: {
        value: '',
        text: ''
      },
      code:'',
      captcha: '' 
    }
  },
  methods:{
    
    async registrame (){      
      if(this.validarCaptcha()){
        this.cargando= true;
        //this.submitted = true;

        this.$v.$touch();
        if(this.$v.$invalid){
          this.cargando = false;
          return;
        }

        try {

          this.usuario.tipo_persona = 3;

           let segundo_apellido = '';

          if(this.usuario.per_segundo_apellido == ''){
            segundo_apellido = 0;
          }
          else{
            segundo_apellido = this.usuario.per_segundo_apellido;
          }

          let usuario = await this.axios.get(`/verifica_persona/${this.usuario.per_numero_documento}/${this.usuario.per_nombres}/${this.usuario.per_primer_apellido}/${segundo_apellido}`);
         
         if(usuario.status == 200){
          let verifica = usuario.data.contenido._verifica_personas;
          
          if(verifica == 1){
            this.cargando = false;
            this.$swal({
              title: 'Información',
              html: `<b>${this.usuario.per_nombres+' '+this.usuario.per_primer_apellido+' '+this.usuario.per_segundo_apellido}</b> ya fúe registrada anteriormente.`,
              type: 'info',
              confirmButtonText: 'Aceptar'
            });
       
            this.usuario.per_numero_documento = '';
            this.usuario.per_nombres = '';
            this.usuario.per_primer_apellido = '';
            this.usuario.per_segundo_apellido = '';
            return;
          }
         }
         let result = await this.axios.get(`/verifica_usuario/${this.usuario.per_numero_documento}`);
         
         if(result.status == 200){
         let verifica = result.data.contenido._verifica_usuarios;
          if(verifica == 1){
            this.cargando = false;
            this.$swal({
              title: 'Información',
              html: `<b>${this.usuario.per_numero_documento}</b> ya fúe registrada anteriormente.`,
              type: 'info',
              confirmButtonText: 'Aceptar'
            });       
            this.usuario.per_numero_documento = '';           
            return;
          }
         }
         this.usuario.tipo_extranjero=this.urldata;
       
          let res = await this.axios.post(`/personaEmp`, this.usuario); 
          
          this.persona = res.data.contenido;
          this.user.usr_usuario = this.persona.per_numero_documento;
          this.user.usr_password = this.persona.per_numero_documento;
          this.user.id_persona = this.persona.id_persona;
          this.user.id_rol = 4;

          await this.axios.post(`/usuarioEmp`, this.user);

          this.cargando= false;
          
          this.$swal({
            title: '<strong>PERSONA REGISTRADA</strong>',
            type: 'success',
            html:
              `<div style='text-align:left'>`+
              'Credenciales para iniciar sesión para declaración de residencia.<br><br>'+
              '<b>Usuario: </b>'+`${this.persona.per_numero_documento}`+'<br>'+
              '<b>Contraseña: </b> Número de Documento'+
              '</div>',
            showCloseButton: true,
            showCancelButton: false,
            focusConfirm: false,
            confirmButtonAriaLabel: 'Entendido!'
          });

          this.$router.go(-1);
        } catch (error) {
          this.$swal({
            title: 'Información',
            text: 'Ocurrio un Error al realizar la consulta!',
            type: 'error',
            confirmButtonText: 'Aceptar'
          });
          this.cargando = false;
        }
      }else{
        this.$swal({
          title: 'Información',
          text: 'Código captcha incorrecto',
          type: 'warning',
          confirmButtonText: 'Aceptar'
        });
      }
         
    },
    async getTipoDocumento() {

        try {
            await this.axios.get(`/getParametros/DOCUMENTO`)
            .then((response)=>{
                this.tipoDocumentos = response.data.contenido;
            })
            .catch((error)=>{
                console.log(error);
                this.$swal({
                  title: 'Información',
                  text: 'Ocurrio un Error al realizar la consulta!',
                  type: 'error',
                  confirmButtonText: 'Aceptar'
                });
            });

        } catch (error) {
            console.log(error);
            this.$swal({
              title: 'Información',
              text: 'Ocurrio un Error al realizar la consulta!',
              type: 'error',
              confirmButtonText: 'Aceptar'
            });
        }  
    },
    async getNacionalidades() {
      try {

        await this.axios.get(`/parametrosPaises`)
        .then((response)=>{
            this.nacionalidades = response.data.contenido;
            // let datosCombo = [];
            // for(let i=0; i<this.nacionalidades.length; i++){
            //     datosCombo.push({"value": this.nacionalidades[i].a3_dgm, "text": this.nacionalidades[i].nombre});
            // }
            // this.options = datosCombo;
            // this.usuario.par_nacionalidad = 'BOL';
        })
        .catch((error)=>{
            console.log(error);
            this.$swal({
              title: 'Información',
              text: 'Ocurrio un Error al realizar la consulta!',
              type: 'error',
              confirmButtonText: 'Aceptar'
            });
        });
      } catch (error) {
          console.log(error);
          this.$swal({
            title: 'Información',
            text: 'Ocurrio un Error al realizar la consulta!',
            type: 'error',
            confirmButtonText: 'Aceptar'
          });
      }  
    },
    crearCaptcha (){
      document.getElementById('captcha').innerHTML = "";
      let charsArray = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
      let lengthOtp = 5;
      let captcha = [];
      for (let i = 0; i < lengthOtp; i++) {
        let index = Math.floor(Math.random() * charsArray.length + 1);
        if (captcha.indexOf(charsArray[index]) == -1)
          captcha.push(charsArray[index]);
        else i--;
      }
      let canv = document.createElement("canvas");
      canv.id = "captcha";
      canv.width = 100;
      canv.height = 50;
      let ctx = canv.getContext("2d");
      ctx.font = "25px Georgia";
      ctx.strokeText(captcha.join(""), 0, 30);
      this.code = captcha.join("");
      document.getElementById("captcha").appendChild(canv);
    },
    validarCaptcha(){
      if (document.getElementById("cpatchaTextBox").value == this.code) {
        console.log('valido');
        return true;
      }else{
        console.log('no valido');
        this.crearCaptcha();
        return false;
      }
    }
  },
  created(){   
    this.getNacionalidades();
    this.getTipoDocumento();
    ///console.log("valor",this.path);
     this.urldata=this.$route.params.id;
    
  },
  mounted(){
    this.crearCaptcha();
    
    
  },
  validations: {
    usuario: {
        per_numero_documento: {required, minLength: minLength(5)},
        per_nombres: {required, minLength: minLength(2), letras},
        per_primer_apellido: {required, minLength: minLength(2), letras},
        per_telefono: {required, minLength: minLength(6),numero},
        per_segundo_apellido: { minLength: minLength(2), letras},
        per_fecha_nacimiento: {required,fechas},
        per_email: {required, email, minLength: minLength(2),correo},
        par_tipo_documento: {required},
        par_nacionalidad: {required},
        par_genero: {required},
        
    },
    captcha: { required }
  }
}
</script>
<style scoped>
  .captcha {
    border: 1
  }
</style>